// extracted by mini-css-extract-plugin
export var container = "_io-0";
export var infoIcon = "_io-2";
export var internalLabel = "_io-3";
export var titleRowCol = "_io-1";